module.exports = __webpack_public_path__ + "static/safra-90a5c1baba65321a26f3184b581708cc.png";